import React from 'react';
export function Footer() {
  return <footer className="py-8 border-t border-border bg-dark" data-id="element-120">
      <div className="max-w-6xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-121">
        <span className="text-sm text-secondary font-medium" data-id="element-122">
          © {new Date().getFullYear()} Karan Dhir
        </span>
        <div className="flex items-center gap-6 text-sm text-secondary font-medium" data-id="element-123">
          <a href="https://www.linkedin.com/in/dhirkaran/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-124">
            LinkedIn
          </a>
          <a href="https://substack.com/@karandhir" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-125">
            Substack
          </a>
          <a href="https://github.com/kd-511" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors" data-id="element-126">
            GitHub
          </a>
        </div>
      </div>
    </footer>;
}